import { createAction, props } from '@ngrx/store';
import { Member, Schema } from '../models/assign-checkbook.model';

export const SearchChanged = createAction(
  '[Checkbooks: Assign Checkbook]: Search Changed',
  props<{ search: string }>(),
);

export const ValidUntilDateChanged = createAction(
  '[Checkbooks: Assign Checkbook]: Valid Until Date Changed',
  props<{ validUntilDate: Date; validUntilDateFormat: string }>(),
);

export const ValidUntilDateCleared = createAction('[Checkbooks: Assign Checkbook]: Valid Until Date Cleared');

export const GetMembers = createAction('[Checkbooks: Assign Checkbook]: Get Members');

export const GetMembersSuccess = createAction(
  '[Checkbooks: Assign Checkbook]: Get Members Success',
  props<{ response: Member[] }>(),
);

export const GetMembersFailed = createAction(
  '[Checkbooks: Assign Checkbook]: Get Members Failed',
  props<{ error: any }>(),
);

export const LoadAssignCheckbookCols = createAction(
  '[Checkbooks: Assign Checkbook]:Load Assign Checkbook Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const GetSchema = createAction('[Checkbooks: Assign Checkbook]: Get Schema');

export const GetSchemaSuccess = createAction(
  '[Checkbooks: Assign Checkbook]: Get Schema Success',
  props<{ response: Schema[] }>(),
);

export const GetSchemaFailed = createAction(
  '[Checkbooks: Assign Checkbook]: Get Schema Failed',
  props<{ error: any }>(),
);

export const NavigateToMember = createAction(
  '[Checkbooks: Assign Checkbook]: Navigate To Member',
  props<{ loyaltyMemberId: number | null }>(),
);

export const NavigateToMemberPageSuccess = createAction('[Checkbooks: Assign Checkbook]: Navigate Member Page Success');

export const NavigateToMemberPageFailed = createAction(
  '[Checkbooks: Assign Checkbook]: Navigate Member Page Failed',
  props<{ error: string }>(),
);

export const SelectedMemberChanged = createAction(
  '[Checkbooks: Assign Checkbook]: Selected Member Changed',
  props<{ selectedMember: number | null }>(),
);

export const Cancel = createAction('[Checkbooks: Assign Checkbook]: Cancel');

export const AssignCheckbook = createAction('[Checkbooks: Assign Checkbook]: Assign Checkbook');

export const AssignCheckbookSuccess = createAction(
  '[Checkbooks: Assign Checkbook]: Assign Checkbook Success',
  props<{ response: any }>(),
);

export const AssignCheckbookFailed = createAction(
  '[Checkbooks: Assign Checkbook]: Assign Checkbook Failed',
  props<{ error: any }>(),
);

export const SubmitAssignCheckbookData = createAction('[Checkbooks: Assign Checkbook]: Submit Assign Checkbook Data');
